import React from 'react';
import styled from 'styled-components';
import Map from './Map';
import CompanyInformations from './CompanyInformations';
import Container from '../../../components/Container';
import DecorationsBlue from '../../../components/DecorationsBlue';
import useWindowWidth from '../../../hooks/useWindowWidth';


const MainWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: repeat(2, auto);
  grid-template-columns: 1fr;
  grid-gap: 40px 0;
  padding-top: 25px;
  padding-bottom: 25px;
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.small}) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    grid-gap: 0 30px;
  }
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}) {
    grid-gap: 0 40px;
  }
  
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.large}) {
    grid-template-columns: 1fr 1fr 230px;
    grid-template-rows: 1fr;
    grid-gap: 0 20px;
  }
`;

const DecorationWrapper = styled.div`
  position: relative;
`;


const MapSection = () => {
  const windowSize = useWindowWidth();

  return (
    <DecorationWrapper>
      <Container>
        <MainWrapper>
          <Map />
          <CompanyInformations />
        </MainWrapper>
      </Container>
      {windowSize > 1000
        && (
          <DecorationsBlue
            height="240px"
            width="20%"
            right="0"
            bottom="0"
            side="right"
          />
        )}
    </DecorationWrapper>
  );
};

export default MapSection;
